import React from 'react'
import PropTypes from 'prop-types'
import ORLogicGate from './ORLogicGate'
import XORLogicGate from './XORLogicGate'
import ANDLogicGate from './ANDLogicGate'
import ToggleLogicGate from './ToggleLogicGate'
import { StyledQueryOperator } from './LogicGateSymbol.style'

const LogicGateSymbol = ({
  isSelected,
  position,
  type,
  operator,
  simulatedValue,
  abGateSimVal,
  cdGateSimVal,
  isSimulating,
}) => {
  const generateQueryGateSymbol = (op) =>
    ({
      and: (
        <ANDLogicGate
          isSelected={isSelected}
          simulatedValue={simulatedValue}
          isSimulating={isSimulating}
        />
      ),
      or: (
        <ORLogicGate
          isSelected={isSelected}
          simulatedValue={simulatedValue}
          isSimulating={isSimulating}
        />
      ),
      xor: (
        <XORLogicGate
          isSelected={isSelected}
          simulatedValue={simulatedValue}
          isSimulating={isSimulating}
        />
      ),
      toggle: (
        <ToggleLogicGate
          isSelected={isSelected}
          simulatedValue={simulatedValue}
          isSimulating={isSimulating}
        />
      ),
    }[op])

  return (
    <StyledQueryOperator
      position={position}
      type={type}
      isSelected={isSelected}
      key={type}
      abGateSimVal={abGateSimVal}
      cdGateSimVal={cdGateSimVal}
      isSimulating={isSimulating}
    >
      {generateQueryGateSymbol(operator)}
    </StyledQueryOperator>
  )
}

LogicGateSymbol.propTypes = {
  operator: PropTypes.string,
  position: PropTypes.string,
  type: PropTypes.string,
  isSelected: PropTypes.bool,
  simulatedValue: PropTypes.bool,
  abGateSimVal: PropTypes.bool,
  cdGateSimVal: PropTypes.bool,
  isSimulating: PropTypes.bool,
}

export default LogicGateSymbol
